import { render, staticRenderFns } from "./IngredientsTable.vue?vue&type=template&id=13dd0768&scoped=true&lang=pug&"
import script from "./IngredientsTable.vue?vue&type=script&lang=js&"
export * from "./IngredientsTable.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsTable.vue?vue&type=style&index=0&id=13dd0768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd0768",
  null
  
)

export default component.exports